class CustomSwitcher extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClick.bind(this));
  }

  onClick() {
    this.classList.toggle("active");
    const switcherState = this.classList.contains("active");
    const switcherEvent = new CustomEvent("switcher-toggle", {
      detail: { state: switcherState },
      bubbles: true,
    });
    this.dispatchEvent(switcherEvent);
  }
}

customElements.define("custom-switcher", CustomSwitcher);
class NearStoreFilter extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const switcher = this.querySelector("custom-switcher");
    let currentStoreCode = getCookie('mor_store_code');
    if (!switcher) return;
    switcher.addEventListener("switcher-toggle", (event) => {
      currentStoreCode = getCookie('mor_store_code');
      const isChecked = event.detail.state;
      const checkboxes = document.querySelectorAll('aside facet-filters-form-intermediate input[name="filter.v.m.custom.store_on_display"]');
      const checkbox = document.querySelector('aside facet-filters-form-intermediate input[name="filter.v.m.custom.store_on_display"][value="' + currentStoreCode + '"]');
      if (checkbox) {
        checkboxes.forEach((cb) => {
          cb.checked = false;
        });
        checkbox.checked = isChecked;
        // 模拟触发facet-filters-form表单的input事件
        const inputEvent = new Event("input", { bubbles: true });
        document.querySelector("aside facet-filters-form-intermediate form").dispatchEvent(inputEvent);
      }
    });
    const currentStore = getStoreByCode(currentStoreCode);
    const storeNameElement = this.querySelector("[data-store-name]");
    if (storeNameElement && currentStore) {
      storeNameElement.textContent = currentStore['ecomm-name'];
    }

    const cancelFilterAction = this.querySelector('.cancel-filter-action')
    if (cancelFilterAction) {
      cancelFilterAction.addEventListener('click', () => {
        const switcherEvent = new CustomEvent("switcher-toggle", {
          detail: { state: false },
          bubbles: true,
        });
        switcher.dispatchEvent(switcherEvent);
      })
    }
  }
}
customElements.define("near-store-filter", NearStoreFilter);
class NearStoreFilterMobile extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const switcher = this.querySelector(".button");
    let currentStoreCode = getCookie('mor_store_code');
    const _this = this;

    if (!switcher) return;
    switcher.addEventListener("click", (event) => {
      currentStoreCode = getCookie('mor_store_code');
      const isChecked = !_this.classList.contains('active');
      const checkboxes = document.querySelectorAll('aside facet-filters-form-intermediate input[name="filter.v.m.custom.store_on_display"]');
      const checkbox = document.querySelector('aside facet-filters-form-intermediate input[name="filter.v.m.custom.store_on_display"][value="' + currentStoreCode + '"]');
      if (checkbox) {
        checkboxes.forEach((cb) => {
          cb.checked = false;
        });
        checkbox.checked = isChecked;
        if (isChecked) {
          _this.classList.add('active')
        } else {
          _this.classList.remove('active')
        }
        // 模拟触发facet-filters-form表单的input事件
        const inputEvent = new Event("input", { bubbles: true });
        document.querySelector("aside facet-filters-form-intermediate form").dispatchEvent(inputEvent);
      }
    });
    const currentStore = getStoreByCode(currentStoreCode);
    const storeNameElement = this.querySelector("[data-store-name]");
    if (storeNameElement && currentStore) {
      storeNameElement.textContent = currentStore['ecomm-name'];
    }
  }
}
customElements.define("near-store-filter-mobile", NearStoreFilterMobile);
class FacetFilterAvailability extends HTMLElement {
  constructor() {
    super();

    // all filter works by submitting this form 'aside facet-filters-form-intermediate form'
    this.availabilityFilters = document.querySelectorAll(
      'aside facet-filters-form-intermediate input[name="filter.p.m.custom.available_regions"]'
    );
    if (!this.availabilityFilters || this.availabilityFilters.length === 0) return;

    this.items = this.querySelectorAll(".filter__availability-item");
    this.items.forEach((item) => {
      item.addEventListener("click", this.onClick.bind(this));
    });
  }
  onClick(event) {
    this.availabilityFilters = document.querySelectorAll(
      'aside facet-filters-form-intermediate input[name="filter.p.m.custom.available_regions"]'
    );
    if (!this.availabilityFilters || this.availabilityFilters.length === 0) return;

    // &filter.p.m.custom.available_regions=00
    if (event.currentTarget.classList.contains("active")) return;
    this.items.forEach((item) => {
      item.classList.remove("active");
    });
    event.currentTarget.classList.add("active");

    const setCheckboxes = (condition) => {
      if (!condition) {
        this.availabilityFilters.forEach((filter) => {
          filter.checked = false;
        });

        return;
      }
      const currentStoreCode = getCookie('mor_store_code');
      if (!currentStoreCode) return;

      for(const filter of this.availabilityFilters) {
        if (filter.value === currentStoreCode) {
          filter.checked = condition;
          return true;
        }
      }
    };

    const coor = event.currentTarget.dataset.coor;
    switch (coor) {
      case "all":
        setCheckboxes(false);
        break;
      case "in-stock":
        setCheckboxes((checkbox) => checkbox.value === "1");
        break;
      case "out-of-stock":
        setCheckboxes((checkbox) => checkbox.value === "0");
        break;
    }

    // 模拟触发facet-filters-form表单的input事件
    const inputEvent = new Event("input", { bubbles: true });
    document.querySelector("aside facet-filters-form-intermediate form").dispatchEvent(inputEvent);
  }
}

customElements.define("facet-filter-availability-intermediate", FacetFilterAvailability);

class FacetFiltersFormIntermediate extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector("form");
    if (facetForm) {
      facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));
    }

    this.initShowControlEvent();

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
    const filterAside = document.querySelector(".filter-aside"),
      verticalTitle = this.querySelector("#verticalTitle");
    if (!filterAside || !verticalTitle) return;
    verticalTitle.addEventListener("click", function () {
      if (verticalTitle.hasAttribute("visible")) {
        verticalTitle.removeAttribute("visible");
        filterAside.parentNode.classList.add("collapse");
      } else {
        verticalTitle.setAttribute("visible", "");
        filterAside.parentNode.classList.remove("collapse");
      }
    });
  }

  connectedCallback() {
    FacetFiltersFormIntermediate.updateMobileFacetSummaryLabels()
  }
  initShowControlEvent(){
    const filterDetailsDomSelector = '.filter-aside [id^="Details-filter"], .filter-aside [id^="Details-Mobile-filter"], .plp-bottom-facet__all [id^="Details-Mobile-filter"]'
    document.querySelectorAll(filterDetailsDomSelector).forEach((filter) => {
      if(filter.querySelector(".filter-size-control")){
        if (filter.querySelector(".filter-size-control").hasAttribute("inited")) return;
        filter.querySelector(".filter-size-control").setAttribute("inited", "");
        filter.querySelector(".filter-size-control").addEventListener("click", () => { 
          filter.querySelectorAll("li").forEach(li => {
            if (li.classList.contains("show-more-item")) {
              li.classList.toggle("hidden");
            }
          });
          
          if(filter.hasAttribute("show")){
            filter.removeAttribute("show");
          } else {
            filter.setAttribute("show", "");
          }
        });
      }
    });
  }

  /** 根据 mobile-facets__item list-menu__item 下 checked 的 input 更新对应 summary 中 .js-mobile-facet-selected-labels 与 .js-mobile-facet-active-count 的显示 */
  static updateMobileFacetSummaryLabels() {
    document.querySelectorAll(".mobile-facets__details.js-filter").forEach((details) => {
      const list = details.querySelector(".mobile-facets__list");
      if (!list) return;
      const labels = [];
      list.querySelectorAll(".mobile-facets__item.list-menu__item").forEach((li) => {
        const input = li.querySelector('input[type="checkbox"]');
        if (input && input.checked) {
          const labelEl = li.querySelector(".facet-checkbox__text-label");
          if (labelEl) labels.push(labelEl.textContent.trim());
        }
      });
      const count = labels.length;
      const summaryLabel = details.querySelector(".mobile-facets__summary .mobile-facets__summary-label");
      if (summaryLabel) {
        const selectedLabelsSpan = summaryLabel.querySelector(".js-mobile-facet-selected-labels");
        if (selectedLabelsSpan) selectedLabelsSpan.textContent = labels.join(", ");
        const countWrap = summaryLabel.querySelector(".js-mobile-facet-count-wrap");
        const countSpan = summaryLabel.querySelector(".js-mobile-facet-active-count");
        if (countWrap) countWrap.style.display = count > 0 ? "" : "none";
        if (countSpan) countSpan.textContent = String(count);
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersFormIntermediate.searchParamsInitial;
      if (searchParams === FacetFiltersFormIntermediate.searchParamsPrev) return;
      FacetFiltersFormIntermediate.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
    document.addEventListener("DOMContentLoaded", () => FacetFiltersFormIntermediate.updateMobileFacetSummaryLabels());
    document.addEventListener("change", (e) => {
      if (e.target.closest("#FacetFiltersFormMobile")) FacetFiltersFormIntermediate.updateMobileFacetSummaryLabels();
    });
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static fullSectionLoading(isLoading) {
    const fullSectionLoadingDom = document.querySelector(".main-collection-product-grid-new1.loading__parent");
    if (fullSectionLoadingDom) {
      fullSectionLoadingDom.classList.toggle("loading", isLoading);
    }
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersFormIntermediate.searchParamsPrev = searchParams;
    const sections = FacetFiltersFormIntermediate.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form-intermediate .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    FacetFiltersFormIntermediate.fullSectionLoading(true);
    
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersFormIntermediate.filterData.some(filterDataUrl)
        ? FacetFiltersFormIntermediate.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersFormIntermediate.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersFormIntermediate.updateURLHash(searchParams);
  }

  static renderSortBy(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const sortByElementFromFetch = parsedHTML.querySelector("facet-filters-form-intermediate.facets.sort_by-top");
    const sortByElementFromDom = document.querySelector("facet-filters-form-intermediate.facets.sort_by-top");
    if (sortByElementFromFetch && sortByElementFromDom) {
      sortByElementFromDom.replaceWith(sortByElementFromFetch);
    }
  }

  static renderPlpBottomFacetAll(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const plpBottomFacetAllFromFetch = parsedHTML.querySelector(".plp-bottom-facet__all .active-facets.active-facets-desktop");
    const plpBottomFacetAllFromDom = document.querySelector(".plp-bottom-facet__all .active-facets.active-facets-desktop");
    if (plpBottomFacetAllFromFetch && plpBottomFacetAllFromDom) {
      plpBottomFacetAllFromDom.replaceWith(plpBottomFacetAllFromFetch);
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersFormIntermediate.filterData = [
          ...FacetFiltersFormIntermediate.filterData,
          { html, url },
        ];
        FacetFiltersFormIntermediate.renderPLPContainer(html);
        FacetFiltersFormIntermediate.renderFilters(html, event);
        // FacetFiltersFormIntermediate.renderProductGridContainer(html);
        // FacetFiltersFormIntermediate.renderProductCount(html);
        // FacetFiltersFormIntermediate.renderStockAvailability(html);
        // FacetFiltersFormIntermediate.renderSelectedFilters(html);
        // FacetFiltersFormIntermediate.renderSortBy(html);
        // FacetFiltersFormIntermediate.renderPlpBottomFacetAll(html);
        document.querySelector('body').classList.remove('overflow-hidden-mobile')
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      })
      .finally(() => {
        FacetFiltersFormIntermediate.fullSectionLoading(false);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersFormIntermediate.filterData.find(filterDataUrl).html;

    FacetFiltersFormIntermediate.renderPLPContainer(html);
    FacetFiltersFormIntermediate.renderFilters(html, event);
    // FacetFiltersFormIntermediate.renderProductGridContainer(html);
    // FacetFiltersFormIntermediate.renderProductCount(html);
    // FacetFiltersFormIntermediate.renderStockAvailability(html);
    // FacetFiltersFormIntermediate.renderSelectedFilters(html);
    // FacetFiltersFormIntermediate.renderSortBy(html);
    // FacetFiltersFormIntermediate.renderPlpBottomFacetAll(html);
    document.querySelector('body').classList.remove('overflow-hidden-mobile')

    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);

    FacetFiltersFormIntermediate.fullSectionLoading(false);
  }

  static renderProductGridContainer(html) {
    const newHtml = new DOMParser().parseFromString(html, "text/html");
    const container = document.querySelector("facet-filters-form-intermediate");
    container.innerHTML = newHtml.querySelector("facet-filters-form-intermediate").innerHTML;
    if (newHtml.querySelector("product-list")) {
      document.querySelector("product-list").innerHTML = newHtml.querySelector("product-list").innerHTML;
    }
    const facetForm = container.querySelector("form");
    if (facetForm) {
      const instance = container;
      facetForm.addEventListener("input", instance.debouncedOnSubmit.bind(instance));
    }

    if (typeof container.initShowControlEvent === 'function') {
      container.initShowControlEvent();
    }

    FacetFiltersFormIntermediate.updateMobileFacetSummaryLabels();

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
    
    document
      ?.getElementById("ProductGridContainer")
      ?.querySelector(".collection")
      ?.classList.remove("loading");
  }

  static renderSelectedFilters(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const selectedFiltersFromFetch = parsedHTML.querySelector(
      "#ProductGridContainer facet-filters-form-intermediate"
    );
    const selectedFiltersFromDom = document.querySelector(
      "#ProductGridContainer facet-filters-form-intermediate"
    );
    if (selectedFiltersFromFetch && selectedFiltersFromDom) {
      selectedFiltersFromDom.replaceWith(selectedFiltersFromFetch);
    }
  }

  static renderStockAvailability(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const availabilityItemsFromFetch1 = parsedHTML.querySelector(
      "menu-drawer.mobile-facets__wrapper > facet-filter-availability-intermediate"
    );
    const availabilityItemsFromDoms = document.querySelectorAll(
      "facet-filter-availability-intermediate"
    );
    if (availabilityItemsFromFetch1 && availabilityItemsFromDoms) {
      availabilityItemsFromDoms.forEach((domItem) => {
        domItem.replaceWith(availabilityItemsFromFetch1.cloneNode(true));
      });
    }
  }

  static renderProductCount(html) {
    if (!new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount")) {
        const loadingSpinners = document.querySelectorAll(
          ".facets-container .loading__spinner, facet-filters-form-intermediate .loading__spinner"
        );
        loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
        return
      } 
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form-intermediate .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersFormIntermediate.renderActiveFacets(parsedHTML);
    FacetFiltersFormIntermediate.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersFormIntermediate.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersFormIntermediate.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details"
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute("type") === "text";

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderPLPContainer(html) {
    const newHtml = new DOMParser().parseFromString(html, "text/html");
    const newContainer = newHtml.querySelector(".plp-container");
    const currentContainer = document.querySelector(".plp-container");
    if (newContainer && currentContainer) {
      currentContainer.replaceWith(newContainer);
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersFormIntermediate.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersFormIntermediate.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form-intermediate form"
    );
    // if (event.srcElement.className == "mobile-facets__checkbox") {
    //   const searchParams = this.createSearchParams(
    //     event.target.closest("form")
    //   );
    //   this.onSubmitForm(searchParams, event);
    // } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetFiltersFormMobile') {
            if (form.checkVisibility()) {
              forms.push(this.createSearchParams(form));
            }
          } else {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile" ||
          form.id === "FacetSortDrawerForm" ||
          form.closest(".pdp-bottom-facet__sort-by")
        ) {
          forms.push(this.createSearchParams(form));
        }
      });
      // remove empty params
      const nonEmptyParams = forms.filter((param) => param);
      // remove repeated params
      const uniqueParams = new Set(nonEmptyParams);
      this.onSubmitForm(Array.from(uniqueParams).join("&"), event);
    // }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersFormIntermediate.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersFormIntermediate.renderPage(url);
  }
}

FacetFiltersFormIntermediate.filterData = [];
FacetFiltersFormIntermediate.searchParamsInitial = window.location.search.slice(1);
FacetFiltersFormIntermediate.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form-intermediate", FacetFiltersFormIntermediate);
FacetFiltersFormIntermediate.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this));
      element.addEventListener("keydown", this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("data-min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("data-min"));
    const max = Number(input.getAttribute("data-max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form-intermediate") ||
      document.querySelector("facet-filters-form-intermediate");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove-intermediate", FacetRemove);
